import { render } from "./LabelSelector.vue?vue&type=template&id=2985c44e&scoped=true"
import script from "./LabelSelector.vue?vue&type=script&lang=js"
export * from "./LabelSelector.vue?vue&type=script&lang=js"

import "./LabelSelector.vue?vue&type=style&index=0&id=2985c44e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2985c44e"],['__file',"src/components/Input/LabelSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2985c44e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2985c44e', __exports__)) {
    api.reload('2985c44e', __exports__)
  }
  
  module.hot.accept("./LabelSelector.vue?vue&type=template&id=2985c44e&scoped=true", () => {
    api.rerender('2985c44e', render)
  })

}


export default __exports__